import { CircularProgress } from '@/UI/CircularProgress/CircularProgress';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { PlayFilledIcon, RestartIcon, XCircleOutlineIcon } from '@/UI/Icons';

const CancellableLoadingButton = ({
  onClick,
  onCancel,
  isProcessing,
  title,
  subtitle,
  data,
  canCancel,
  disabled,
  shouldShowEndIcon,
  size = 'medium',
  cancelIcon = <XCircleOutlineIcon width={16} height={16} />,
}) => {
  const renderButton = () => {
    let endIcon;
    let localDisabled = disabled;
    if (isProcessing) {
      endIcon = <CircularProgress size="16px" sx={{ color: 'rgba(255, 255, 255, 0.3)' }} />;
      localDisabled = !canCancel;
    } else {
      endIcon = data.result && data.result.length > 0 ? <RestartIcon /> : <PlayFilledIcon />;
    }

    //todo: replace loading button with regular one
    return (
      <ButtonContained
        onClick={() => (isProcessing ? onCancel() : onClick())}
        endIcon={shouldShowEndIcon && endIcon}
        startIcon={isProcessing && canCancel ? cancelIcon : null}
        fullWidth
        disabled={localDisabled}
        size={size}
      >
        {title}
        {subtitle}
      </ButtonContained>
    );
  };

  return renderButton();
};

export default CancellableLoadingButton;
